import { useEffect, useState } from "react";
import ModalComponent from "../common/Modal/modal";
import { downloadFileDataStatus, getDownloadedFile, getErrorFile, uploadFileDataStatus } from "./apiController";
import { Col, Row } from "reactstrap";
import { DownloadOutlined } from "@ant-design/icons";

// Props interface for the component
interface Props {
    id: string; // ID of the uploaded file or batch
    onClose: () => void; // Function to handle modal close
}

const DownloadStatusModal: React.FC<Props> = (props) => {
    // State to hold the upload status data
    const [statusData, setStatusData] = useState<any>([{ download_file_names: [], status: "", id: "", form_id: "", created_at: "" }]);

    // Fetch the upload status when the component is mounted
    useEffect(() => {
        getUploadStatus();
    }, []);

    /**
     * Fetch the upload status of all files.
     */
    const getUploadStatus = async () => {
        try {
            let response = await downloadFileDataStatus(props.id);
            if (response) {
                setStatusData(response.data); // Update the state with the fetched data
            }
        } catch (error) {
            console.error("File Upload Error", error);
        }
    };

    /**
     * Download the error file for all failed records.
     * @param id - ID of the file for which errors need to be downloaded
     * @param filename - Name of the uploaded file
     */
    const getDownloadDataFile = async (id: string) => {
        try {
            let response = await getDownloadedFile(id);
            console.log(response)
            const blob = new Blob([response], { type: "application/zip" });
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.setAttribute("download", "file.zip"); // Set download file name
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            // const blob = new Blob([response], { type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document" });
            // const url = URL.createObjectURL(blob);
            // const link = document.createElement("a");
            // link.href = url;
            // link.download = `Data_${id}`;
            // link.click();
            // URL.revokeObjectURL(url); // Clean up the object URL
        } catch (error) {
            console.error("Error downloading file", error);
        }
    };

    return (
        <>
            <ModalComponent
                width={"90%"}
                isOpen={true}
                onClose={props.onClose}
                header={"Downloaded File Status"}
                centered={true}
                customClass="criteria-modal"
                body={
                    <>
                        {/* Header section for the status list */}
                        <div className="status-card-head">
                            <Row>
                                <Col md={6} xs={12}>
                                    <strong>Download File Name</strong>
                                </Col>
                                <Col md={4} xs={12}>
                                    <strong>Status</strong>
                                </Col>
                                <Col md={2} xs={12}>
                                    <strong>Action</strong>
                                </Col>
                            </Row>
                        </div>

                        {/* List of uploaded file statuses */}
                        <div className="upload-status-list">
                            {statusData && statusData.map((item, index) => (
                                <div className="status-card" key={index}>
                                    <Row>
                                        {/* File name column */}
                                        <Col md={6} xs={12}>
                                            {item.id}
                                        </Col>

                                        {/* Status column with conditional styling */}
                                        <Col md={4} xs={6}>
                                            <div
                                                className="status"
                                                style={
                                                    item.status === "successful"
                                                        ? { backgroundColor: "Green", width: "fit-content" }
                                                        : item.status === "failed"
                                                            ? { backgroundColor: "Red", width: "fit-content" }
                                                            : { backgroundColor: "Orange", width: "fit-content" }
                                                }
                                            >
                                                {item.status}
                                            </div>
                                        </Col>

                                        {/* Action column for downloading error files */}
                                        <Col md={2} xs={6}>
                                            <div>
                                                {item.status === "successful" ? (
                                                    <DownloadOutlined
                                                        onClick={() => getDownloadDataFile(item.id)}
                                                    />
                                                ) : (
                                                    "-"
                                                )}
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            ))}
                        </div>
                    </>
                }
                footer={<></>} // Empty footer
            />
        </>
    );
};

export default DownloadStatusModal;
